import React from 'react';
import { Code, Database, Layers, Award, Briefcase, GraduationCap, Trophy, Zap } from 'lucide-react';

export default function About({ darkMode, language }) {
  const isRTL = language === 'ar';
  
  const content = {
    fr: {
      title: "À Propos de Moi",
      intro: "Développeur Full-Stack passionné avec plus de 4 ans d'expérience spécialisé dans les systèmes de gestion scolaire, plateformes e-commerce et sites web d'entreprise.",
      description: "Je me spécialise dans la conception et le développement de solutions numériques complètes. Mon expertise couvre l'ensemble du cycle de développement, de la conception UX/UI à l'architecture backend robuste, en passant par l'intégration d'APIs tierces.",
      skills: "Compétences Techniques",
      skillsList: [
        { icon: Code, name: "Frontend", tech: "React, Angular, HTML/CSS, Tailwind, Bootstrap, JavaScript" },
        { icon: Database, name: "Backend", tech: "Laravel, Node.js, Express, Flask, PHP, Python" },
        { icon: Layers, name: "Database", tech: "MySQL, MongoDB, PostgreSQL, Oracle" },
        { icon: Award, name: "Outils", tech: "Git, Figma, WordPress, Power BI, Agile" }
      ],
      education: "Formation",
      educationList: [
        { 
          degree: "4ème année Cycle d'Ingénieur - Génie Informatique", 
          school: "SUPEMIR", 
          year: "2025-2026",
          status: "En cours"
        },
        { 
          degree: "Licence Développement Informatique", 
          school: "SUPEMIR", 
          year: "2024-2025"
        },
        { 
          degree: "Technicien Spécialisé Full-Stack - Développement Digital", 
          school: "OFPPT", 
          year: "2022-2024"
        }
      ],
      experience: "Expérience",
      experienceYears: "années",
      experienceList: [
        {
          role: "Membre d'Équipe IT",
          company: "SUPEMIR",
          period: "2025 - Présent",
          achievement: "Créateur et vendeur du système complet de gestion scolaire"
        },
        {
          role: "Chef d'Équipe IT",
          company: "École Alfred Kastler",
          period: "2024 - Présent",
          achievement: "Lead Developer - Plateforme avec QR badges, portail parents et intégration WhatsApp"
        },
        {
          role: "Développeur Freelance",
          company: "Multiple Clients",
          period: "2023 - Présent",
          achievement: "10+ projets réussis incluant e-commerce, sites corporate et systèmes de gestion"
        }
      ],
      expertise: "Domaines d'Expertise",
      expertiseList: [
        "Systèmes de Gestion Scolaire",
        "Plateformes E-commerce",
        "Sites Web d'Entreprise",
        "Dashboards Analytics",
        "Intégrations API",
        "Architecture MERN Stack"
      ],
      languages: "Langues",
      languagesList: [
        { name: "Arabe", level: "Natif", flag: "🇲🇦" },
        { name: "Français", level: "Courant", flag: "🇫🇷" },
        { name: "Anglais", level: "Courant", flag: "🇬🇧" }
      ]
    },
    ar: {
      title: "من أنا",
      intro: "مطور Full-Stack شغوف بأكثر من 4 سنوات خبرة متخصص في أنظمة إدارة المدارس، منصات التجارة الإلكترونية ومواقع الشركات.",
      description: "أتخصص في تصميم وتطوير حلول رقمية متكاملة. تغطي خبرتي دورة التطوير الكاملة، من تصميم UX/UI إلى البنية الخلفية القوية، مرورا بتكامل APIs الخارجية.",
      skills: "المهارات التقنية",
      skillsList: [
        { icon: Code, name: "الواجهة الأمامية", tech: "React, Angular, HTML/CSS, Tailwind, Bootstrap, JavaScript" },
        { icon: Database, name: "الواجهة الخلفية", tech: "Laravel, Node.js, Express, Flask, PHP, Python" },
        { icon: Layers, name: "قاعدة البيانات", tech: "MySQL, MongoDB, PostgreSQL, Oracle" },
        { icon: Award, name: "الأدوات", tech: "Git, Figma, WordPress, Power BI, Agile" }
      ],
      education: "التعليم",
      educationList: [
        { 
          degree: "السنة الرابعة دورة المهندس - هندسة المعلوميات", 
          school: "SUPEMIR", 
          year: "2025-2026",
          status: "جاري"
        },
        { 
          degree: "إجازة تطوير المعلوميات", 
          school: "SUPEMIR", 
          year: "2024-2025"
        },
        { 
          degree: "تقني متخصص Full-Stack - التطوير الرقمي", 
          school: "OFPPT", 
          year: "2022-2024"
        }
      ],
      experience: "الخبرة",
      experienceYears: "سنوات",
      experienceList: [
        {
          role: "عضو فريق IT",
          company: "SUPEMIR",
          period: "2025 - الحاضر",
          achievement: "مبتكر وبائع النظام الكامل لإدارة المدرسة"
        },
        {
          role: "رئيس فريق IT",
          company: "مدرسة Alfred Kastler",
          period: "2024 - الحاضر",
          achievement: "المطور الرئيسي - منصة مع بطاقات QR، بوابة الآباء وتكامل WhatsApp"
        },
        {
          role: "مطور مستقل",
          company: "عملاء متعددون",
          period: "2023 - الحاضر",
          achievement: "أكثر من 5 مشاريع ناجحة تشمل التجارة الإلكترونية، مواقع الشركات وأنظمة الإدارة"
        }
      ],
      expertise: "مجالات الخبرة",
      expertiseList: [
        "أنظمة إدارة المدارس",
        "منصات التجارة الإلكترونية",
        "مواقع الشركات",
        "لوحات تحليلية",
        "تكامل APIs",
        "بنية MERN Stack"
      ],
      languages: "اللغات",
      languagesList: [
        { name: "العربية", level: "الأم", flag: "🇲🇦" },
        { name: "الفرنسية", level: "متقن", flag: "🇫🇷" },
        { name: "الإنجليزية", level: "متقن", flag: "🇬🇧" }
      ]
    }
  };

  const t = content[language];

  return (
    <section className="px-4 pt-8 pb-12 min-h-screen">
      <div className="max-w-7xl mx-auto w-full flex flex-col lg:flex-row gap-6 sm:gap-12 items-start">

        {/* LEFT COLUMN - TEXT CONTENT */}
        <div className={`${isRTL ? 'text-right' : 'text-left'} w-full lg:w-2/3`}>
          <h1 className={`text-3xl sm:text-4xl md:text-5xl font-bold mb-4 ${isRTL ? 'font-arabic' : ''}`}>
            {t.title}
          </h1>
          
          <div className="mb-8">
            <p className={`text-lg sm:text-xl font-bold mb-4 leading-snug ${isRTL ? 'font-arabic' : ''}`}>
              <span className="bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
                {t.intro}
              </span>
            </p>
            <p className={`text-base text-gray-400 leading-relaxed ${isRTL ? 'font-arabic' : ''}`}>
              {t.description}
            </p>
          </div>

          <h2 className={`text-xl sm:text-2xl font-bold mb-4 ${isRTL ? 'font-arabic' : ''}`}>
            <span className="bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
              {t.skills}
            </span>
          </h2>
          
          <div className="grid sm:grid-cols-2 gap-4 mb-8">
            {t.skillsList.map((skill, i) => (
              <div key={i} className={`${darkMode ? 'bg-gray-800' : 'bg-white'} p-4 rounded-xl border ${darkMode ? 'border-gray-700' : 'border-gray-200'} hover:border-blue-500 transition-all group`}>
                <div className={`flex items-start gap-3 ${isRTL ? 'flex-row-reverse' : ''}`}>
                  <skill.icon className="text-blue-500 group-hover:scale-110 transition-transform flex-shrink-0" size={20} />
                  <div className={isRTL ? 'text-right' : 'text-left'}>
                    <h3 className={`font-bold text-base mb-1 ${isRTL ? 'font-arabic' : ''}`}>{skill.name}</h3>
                    <p className={`text-sm text-gray-400 ${isRTL ? 'font-arabic' : ''}`}>{skill.tech}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <h2 className={`text-xl sm:text-2xl font-bold mb-4 ${isRTL ? 'font-arabic' : ''}`}>
            <span className="bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
              {t.education}
            </span>
          </h2>
          
          <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-xl border ${darkMode ? 'border-gray-700' : 'border-gray-200'} overflow-hidden mb-8`}>
            {t.educationList.map((edu, i) => (
              <div key={i} className={`p-4 ${i !== t.educationList.length - 1 ? `border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}` : ''} ${edu.status ? 'bg-gradient-to-r from-blue-500/10 to-purple-600/10' : ''}`}>
                <div className={`flex flex-col sm:flex-row sm:items-center gap-3 ${isRTL ? 'sm:flex-row-reverse' : ''}`}>
                  <div className="flex-1">
                    <h3 className={`font-bold text-base ${isRTL ? 'font-arabic' : ''}`}>{edu.degree}</h3>
                  </div>
                  {edu.status && (
                    <span className="px-3 py-1 bg-gradient-to-r from-blue-500 to-purple-600 text-white text-xs rounded-full font-semibold whitespace-nowrap self-start sm:self-auto">
                      {edu.status}
                    </span>
                  )}
                  <div className={`text-left sm:text-right ${isRTL ? 'sm:text-left' : ''}`}>
                    <p className={`text-blue-500 text-sm font-semibold ${isRTL ? 'font-arabic' : ''}`}>{edu.school}</p>
                    <p className="text-gray-400 text-xs">{edu.year}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <h2 className={`text-xl sm:text-2xl font-bold mb-4 ${isRTL ? 'font-arabic' : ''}`}>
            <span className="bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
              {t.experience}
            </span>
          </h2>
          
          <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-xl border ${darkMode ? 'border-gray-700' : 'border-gray-200'} overflow-hidden mb-8`}>
            {t.experienceList.map((exp, i) => (
              <div key={i} className={`p-4 ${i !== t.experienceList.length - 1 ? `border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}` : ''}`}>
                <div className={`flex flex-col sm:flex-row sm:items-center sm:justify-between mb-3 gap-2 ${isRTL ? 'sm:flex-row-reverse' : ''}`}>
                  <div>
                    <h3 className={`font-bold text-base ${isRTL ? 'font-arabic' : ''}`}>{exp.role}</h3>
                    <p className={`text-sm font-semibold ${isRTL ? 'font-arabic' : ''}`}>
                      <span className="bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
                        {exp.company}
                      </span>
                    </p>
                  </div>
                  <span className="text-xs text-gray-500 self-start sm:self-auto">{exp.period}</span>
                </div>
                <div className={`flex items-start gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}>
                  <Trophy className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0" />
                  <p className={`text-sm text-gray-600 dark:text-gray-400 ${isRTL ? 'font-arabic' : ''}`}>{exp.achievement}</p>
                </div>
              </div>
            ))}
          </div>

          <h2 className={`text-xl sm:text-2xl font-bold mb-4 ${isRTL ? 'font-arabic' : ''}`}>
            <span className="bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
              {t.expertise}
            </span>
          </h2>
          
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8">
            {t.expertiseList.map((item, i) => (
              <div key={i} className={`${darkMode ? 'bg-gray-800' : 'bg-white'} p-3 rounded-lg border ${darkMode ? 'border-gray-700' : 'border-gray-200'} hover:border-blue-500 transition-colors flex items-center gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}>
                <Zap className="w-4 h-4 text-blue-500 flex-shrink-0" />
                <span className={`text-xs font-medium ${isRTL ? 'font-arabic text-right' : ''}`}>{item}</span>
              </div>
            ))}
          </div>

          <h2 className={`text-xl sm:text-2xl font-bold mb-4 ${isRTL ? 'font-arabic' : ''}`}>
            <span className="bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
              {t.languages}
            </span>
          </h2>
          
          <div className="grid grid-cols-3 gap-3">
            {t.languagesList.map((lang, i) => (
              <div key={i} className={`${darkMode ? 'bg-gray-800' : 'bg-white'} p-4 rounded-xl border ${darkMode ? 'border-gray-700' : 'border-gray-200'} text-center hover:border-blue-500 transition-colors`}>
                <div className="text-2xl mb-2">{lang.flag}</div>
                <p className={`font-bold text-sm ${isRTL ? 'font-arabic' : ''}`}>{lang.name}</p>
                <p className={`text-xs text-gray-400 ${isRTL ? 'font-arabic' : ''}`}>{lang.level}</p>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT COLUMN - VISUAL ELEMENTS */}
        <div className="w-full lg:w-1/3 relative mt-8 lg:mt-0">
          <div className="lg:sticky lg:top-8">
            <div className="relative w-full">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-purple-600/20 rounded-2xl blur-3xl"></div>
              
              <div className={`relative ${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-2xl p-6 border ${darkMode ? 'border-gray-700' : 'border-gray-200'} shadow-lg`}>
                <div className="text-center">
                  <div className="inline-block p-4 rounded-xl bg-gradient-to-r from-blue-500/10 to-purple-600/10 mb-4">
                    <Award className="text-blue-500 mx-auto" size={36} />
                  </div>
                  <h3 className={`text-lg font-bold mb-3 ${isRTL ? 'font-arabic' : ''}`}>
                    {t.experience}
                  </h3>
                  <p className="text-4xl font-bold bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">4+</p>
                  <p className={`text-gray-400 mt-2 text-base ${isRTL ? 'font-arabic' : ''}`}>
                    {t.experienceYears}
                  </p>
                </div>

                <div className="mt-6 space-y-3">
                  <div className="flex items-center justify-between p-3 bg-gradient-to-r from-blue-500/10 to-purple-600/10 rounded-lg border border-blue-500/20">
                    <span className={`text-sm font-semibold ${isRTL ? 'font-arabic' : ''}`}>Projets</span>
                    <span className="text-lg font-bold bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">10+</span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-gradient-to-r from-blue-500/10 to-purple-600/10 rounded-lg border border-blue-500/20">
                    <span className={`text-sm font-semibold ${isRTL ? 'font-arabic' : ''}`}>Leadership</span>
                    <span className="text-lg font-bold bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">2</span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-gradient-to-r from-blue-500/10 to-purple-600/10 rounded-lg border border-blue-500/20">
                    <span className={`text-sm font-semibold ${isRTL ? 'font-arabic' : ''}`}>Clients</span>
                    <span className="text-lg font-bold bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">10+</span>
                  </div>
                </div>
              </div>

              <div className="absolute -top-3 -right-3 w-16 h-16 bg-blue-500 rounded-xl opacity-20 animate-pulse"></div>
              <div className="absolute -bottom-3 -left-3 w-20 h-20 bg-purple-600 rounded-xl opacity-20 animate-pulse"></div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}